import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestFormPage.XeroAmaxPayBatchPaymentForm.PaymentDetailsDiscrepanciesPopupContent',
    {
        title: 'Batch Payment check',
        cancel: 'cancel',
        apply: 'apply',
        beforeTable: 'Following contact payment details were edited during the request creation process',
        afterTable: 'Last actual contact payment details will be applied to the request',
        tableHeaderContact: 'Contact payment details',
        tableHeaderDiscrepancy: 'Discrepancy',
    }
);
